import { render, staticRenderFns } from "./BonusUsages.vue?vue&type=template&id=665bea8d&"
import script from "./BonusUsages.vue?vue&type=script&lang=js&"
export * from "./BonusUsages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports